import { ActionReducerMapBuilder, createSlice } from "@reduxjs/toolkit";

import type { InterestForm } from "../@types";
import { clearInterestForms, createInterestForm, deleteInterestForm, editInterestForm, getInterestForm, getInterestForms } from "../actions/interests";

type LoadState = "idle" | "pending" | "succeeded" | "failed";

interface INTEREST_FORMS_STATE {
  items: InterestForm[];
  status: LoadState;
  error: any;
}

const initialState: INTEREST_FORMS_STATE = {
  items: [],
  status: "idle",
  error: null,
};

const interestFormsSlice = createSlice({
  name: "interestForms",
  initialState,
  reducers: {},
  extraReducers(builder: ActionReducerMapBuilder<INTEREST_FORMS_STATE>) {
    builder
      // list
      .addCase(getInterestForms.pending, (s) => { s.status = "pending"; s.error = null; })
      .addCase(getInterestForms.fulfilled, (s, a) => { s.items = a.payload; s.status = "succeeded"; })
      .addCase(getInterestForms.rejected, (s, a) => { s.status = "failed"; s.error = a.payload ?? a.error; })

      // create
      .addCase(createInterestForm.pending, (s) => { s.status = "pending"; s.error = null; })
      .addCase(createInterestForm.fulfilled, (s, a) => { s.items.push(a.payload); s.status = "succeeded"; })
      .addCase(createInterestForm.rejected, (s, a) => { s.status = "failed"; s.error = a.payload ?? a.error; })

      // delete
      .addCase(deleteInterestForm.pending, (s) => { s.status = "pending"; s.error = null; })
      .addCase(deleteInterestForm.fulfilled, (s, a) => {
        const id = Number(a.payload);
        s.items = s.items.filter((it) => it.id !== id);
        s.status = "succeeded";
      })
      .addCase(deleteInterestForm.rejected, (s, a) => { s.status = "failed"; s.error = a.payload ?? a.error; })

      // edit
      .addCase(editInterestForm.pending, (s) => { s.status = "pending"; s.error = null; })
      .addCase(editInterestForm.fulfilled, (s, a) => {
        const updated = a.payload;
        const idx = s.items.findIndex((it) => it.id === updated.id);
        if (idx >= 0) s.items[idx] = updated;
        s.status = "succeeded";
      })
      .addCase(editInterestForm.rejected, (s, a) => { s.status = "failed"; s.error = a.payload ?? a.error; })

      // get single
      .addCase(getInterestForm.pending, (s) => { s.status = "pending"; s.error = null; })
      .addCase(getInterestForm.fulfilled, (s, a) => {
        const item = a.payload;
        const idx = s.items.findIndex((it) => it.id === item.id);
        if (idx >= 0) s.items[idx] = item; else s.items.push(item);
        s.status = "succeeded";
      })
      .addCase(getInterestForm.rejected, (s, a) => { s.status = "failed"; s.error = a.payload ?? a.error; })

      // clear
      .addCase(clearInterestForms.fulfilled, () => ({ ...initialState }));
  },
});

export default interestFormsSlice.reducer;
